import React from 'react'

interface AlmaIconProps {
  width?: string | number
  height?: string | number
}

export const AlmaIcon: React.FC<AlmaIconProps> = ({
  width = '21',
  height = '21'
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21 21"
    fill="none"
    role="img"
    aria-label="Alma Icon"
  >
    <g clipPath="url(#clip0_2313_1192)">
      <circle cx="10.75" cy="10.6904" r="10" fill="#02291C" />
      <path
        d="M7.73724 12.7493C7.90721 12.7738 8.05277 12.7446 8.14056 12.7273C8.1922 12.7169 8.23871 12.7047 8.27862 12.6925C8.32697 12.6775 8.35934 12.632 8.35609 12.5812L8.32838 12.1779C8.32414 12.1145 8.26642 12.0685 8.20299 12.0784H8.20162C8.13306 12.0887 8.09876 12.0939 8.05748 12.0906C8.01144 12.0868 7.94948 12.0817 7.90066 12.038C7.83021 11.9746 7.83539 11.8737 7.83634 11.8554V8.19969C7.83634 8.12175 7.77338 8.05884 7.69544 8.05884H7.25787C7.17993 8.05884 7.11702 8.12175 7.11702 8.19969V12.0211C7.11372 12.0746 7.10105 12.3733 7.31564 12.5742C7.46068 12.7094 7.6396 12.7353 7.73724 12.7493Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.94368 12.7113H6.36766C6.46673 12.7113 6.53481 12.6122 6.49912 12.5197L4.83045 8.19594C4.80979 8.14148 4.75721 8.1058 4.69899 8.1058H4.13885C4.08063 8.1058 4.02851 8.14148 4.00739 8.19594L2.33871 12.5197C2.30303 12.6122 2.37111 12.7113 2.47018 12.7113H2.88054C2.93876 12.7113 2.99088 12.6756 3.012 12.6212L3.35851 11.7234C3.3618 11.7145 3.37072 11.7084 3.38058 11.7084H5.44364C5.45351 11.7084 5.46196 11.7145 5.46571 11.7234L5.81222 12.6212C5.83288 12.6752 5.88546 12.7113 5.94368 12.7113ZM3.62567 11.0333L4.38676 9.04765C4.39427 9.02746 4.42291 9.02746 4.43042 9.04765L5.19809 11.0333C5.20419 11.0487 5.19245 11.0652 5.17602 11.0652H3.64773C3.63083 11.0652 3.61956 11.0487 3.62567 11.0333Z"
        fill="white"
      />
      <path
        d="M11.9408 9.79325C12.1827 9.4613 12.5907 9.19837 13.1649 9.19837C13.9668 9.19837 14.3955 9.70311 14.3955 10.5605V12.57C14.3955 12.6479 14.3326 12.7109 14.2546 12.7109H13.8171C13.7391 12.7109 13.6762 12.6479 13.6762 12.57V10.6159C13.6762 10.1731 13.4616 9.86885 12.964 9.86885C12.5282 9.86885 12.1963 10.1384 12.0996 10.5327V12.57C12.0996 12.6479 12.0366 12.7109 11.9587 12.7109H11.5211C11.4431 12.7109 11.3802 12.6479 11.3802 12.57V10.6159C11.3802 10.1731 11.1657 9.86885 10.668 9.86885C10.2323 9.86885 9.90032 10.1384 9.80358 10.5327V12.57C9.80358 12.6479 9.74067 12.7109 9.66273 12.7109H9.22516C9.14722 12.7109 9.08431 12.6479 9.08431 12.57V10.1388C9.08431 9.97966 9.00119 9.91064 8.86317 9.91064C8.84955 9.91064 8.8364 9.91111 8.82373 9.91204C8.74579 9.91721 8.67817 9.85946 8.67251 9.78105L8.64905 9.42985C8.64481 9.36412 8.6866 9.30449 8.74998 9.28524C8.83311 9.25941 8.9331 9.24016 9.08431 9.24016C9.47166 9.24016 9.71344 9.42703 9.78294 9.73785C9.99047 9.43361 10.3501 9.19837 10.8685 9.19837C11.3878 9.19837 11.7544 9.41294 11.9408 9.79325Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9574 12.1561C19.0231 12.1561 19.0935 12.142 19.1593 12.1232C19.2344 12.0997 19.3142 12.142 19.3376 12.2171L19.4127 12.4659C19.4315 12.5316 19.4034 12.5973 19.347 12.6302C19.1686 12.7241 18.9761 12.771 18.7978 12.771C18.3893 12.771 18.042 12.5269 17.9903 12.0575C17.7415 12.5269 17.2767 12.771 16.6853 12.771C15.6149 12.771 15.0187 11.9401 15.0187 10.9871C15.0187 10.0341 15.6009 9.17505 16.6758 9.17505C17.2627 9.17505 17.6993 9.41917 17.9199 9.83697V9.40039C17.9199 9.32058 17.9809 9.25956 18.0608 9.25956H18.4457C18.5255 9.25956 18.5865 9.32058 18.5865 9.40039V11.7476C18.5865 12.0293 18.7602 12.1561 18.9574 12.1561ZM15.6947 10.973C15.6947 11.6725 16.136 12.1607 16.7932 12.1607C17.4411 12.1607 17.9058 11.6772 17.9058 10.973C17.9058 10.2689 17.4504 9.78534 16.7838 9.78534C16.0703 9.78534 15.6947 10.3299 15.6947 10.973Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2313_1192">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.75 0.69043)"
        />
      </clipPath>
    </defs>
  </svg>
)
